import * as tslib_1 from "tslib";
import { handleDeleteItemsAction as handleDeleteItemsActionBase, handleFetchSuccessAction, } from '../base/actionHandlers';
/**
 * Inserts a set of items into the stream at a given offset
 *
 * IMPORTANT: We do best guess with nextOffset tracking, as its
 * backend dependent please think about using this before using it!
 * Some backends or UX cases might not handle our simple method of
 * moving the next offset pointer forward.
 *
 * This is also not available for cursor based things because there
 * is no way to cleanly increment the offset.
 *
 * @param streamState
 * @param action
 */
export var handleInsertItemsAction = function (streamState, action) {
    var nextOffset = streamState.nextOffset !== undefined
        ? streamState.nextOffset + action.items.length
        : undefined;
    var total = streamState.total !== undefined
        ? streamState.total + action.items.length
        : undefined;
    // Prepend - optimisation concat faster than slice and spread
    if (action.offset === 0) {
        return tslib_1.__assign({}, streamState, { nextOffset: nextOffset, items: action.items.concat(streamState.items || []), total: total });
    }
    // Append - optimisation concat faster than slice and spread
    if (action.offset === streamState.items.length) {
        return tslib_1.__assign({}, streamState, { nextOffset: nextOffset, items: (streamState.items || []).concat(action.items), total: total });
    }
    // Inject
    var current = streamState.items || [];
    var newItems = current.slice(0, action.offset).concat(action.items, current.slice(action.offset));
    return tslib_1.__assign({}, streamState, { nextOffset: nextOffset, items: newItems, total: total });
};
/**
 * Merges in fetch results. This operates under the assumption that
 * there are no duplicate items in the stream; and if there are dupes
 * in the fetched stream they must be the result of accidental double-fetching
 * and can be safely discarded.
 *
 * IMPORTANT: do not use on streams that can possibly hold duplicates!
 * If unsure, do not use!
 *
 * @param streamState
 * @param action
 */
export var dedupeFetchResults = function (streamState, action) {
    var _a = streamState.items, items = _a === void 0 ? [] : _a;
    var actionItems = action.items, _b = action.dedupeFunction, dedupeFunction = _b === void 0 ? function (item, existingItems) { return !existingItems.includes(item); } : _b, nextOffset = action.nextOffset, baseAction = tslib_1.__rest(action, ["items", "dedupeFunction", "nextOffset"]);
    if (streamState.nextOffset &&
        nextOffset &&
        nextOffset <= streamState.nextOffset) {
        // we already got all we had in this fetch
        return streamState;
    }
    // we want to dedupe already existing items from the stream
    var filteredItems = actionItems.filter(function (item) { return dedupeFunction(item, items); });
    return tslib_1.__assign({}, handleFetchSuccessAction(streamState, tslib_1.__assign({}, baseAction, { items: filteredItems })), { nextOffset: nextOffset });
};
export var handleDeleteItemsAction = function (streamState, action) {
    var items = streamState.items, nextOffset = streamState.nextOffset;
    var prevItemsCount = items.length;
    var newStreamState = handleDeleteItemsActionBase(streamState, action);
    var removedItemsCount = prevItemsCount - newStreamState.items.length;
    if (nextOffset !== undefined && nextOffset !== null) {
        return tslib_1.__assign({}, newStreamState, { nextOffset: nextOffset - removedItemsCount });
    }
    return newStreamState;
};
//# sourceMappingURL=actionHandlers.js.map